import { format, startOfYear } from "date-fns";
import { StatementPeriod } from "@/openapi/generated";

export const DEFAULT_STATEMENT_PERIOD = StatementPeriod.All;

export interface StatementPeriodOption {
  value: StatementPeriod;
  label: string;
}

export const STATEMENT_PERIOD_OPTIONS: StatementPeriodOption[] = [
  { value: StatementPeriod.CurrentMonth, label: "This month" },
  { value: StatementPeriod.YearToDate, label: "Year to date" },
  { value: StatementPeriod.MultiYear, label: "Last 3 years" },
  { value: StatementPeriod.All, label: "All time" },
];

export function shouldShowYearlyBreakdown(
  period: StatementPeriod,
  yearCount: number,
): boolean {
  if (yearCount <= 0) return false;
  if (period === StatementPeriod.MultiYear) return true;
  return period === StatementPeriod.All && yearCount > 1;
}

export function getStatementPeriodCaption(
  period: StatementPeriod,
  now = new Date(),
): string {
  switch (period) {
    case StatementPeriod.CurrentMonth:
      return `${format(now, "MMMM yyyy")} · posted and paid in this calendar month; balance due is as of today`;
    case StatementPeriod.YearToDate:
      return `${format(startOfYear(now), "MMM d")} – ${format(now, "MMM d, yyyy")} · posted and paid in range; balance due is as of today`;
    case StatementPeriod.MultiYear:
      return `${now.getFullYear() - 2}–${now.getFullYear()} · posted and paid in range; balance due is as of today`;
    case StatementPeriod.All:
      return "All posted and paid activity · balance due is as of today";
    default:
      return `${format(now, "MMMM yyyy")} · posted and paid in this calendar month; balance due is as of today`;
  }
}
